import moment from "moment-timezone";
import TimezonePicker from "react-timezone";
import { useTranslation } from "react-i18next";
import { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import {
  putTeachers,
  getCountries,
  postTeachers,
  getTeachersById,
  getGlobalLanguages,
  postTeacheravailabilities,
} from "../../store/middleware";
import PhotoAvatar from "../../components/PhotoAvatar";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import { SCButtonAddInput } from "../../components/Buttons/styles";
import ModalChangePassword from "../../components/ModalChangePassword";

const optionsPayment = [
  { value: "check", label: "Check" },
  { value: "payoneer", label: "Payoneer" },
  { value: "paypal", label: "Paypal" },
  { value: "remitly", label: "Remitly" },
  { value: "wu", label: "WU" },
  { value: "zelle", label: "Zelle" },
];

function ManageAccount() {
  const { id } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.userReducer);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("");
  const [picture, setPicture] = useState("");
  const [address, setAddress] = useState("");
  const [timezone, setTimezone] = useState("");
  const [teacherId, setTeacherId] = useState(0);
  const [countryId, setCountryId] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [countries, setCountries] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [paymentID, setPaymentID] = useState("");
  const [alerttitle, setAlertTitle] = useState("");
  const [openalert, setOpenAlert] = useState(false);
  const [demoClass, setDemoClass] = useState(false);
  const [paymentType, setPaymentType] = useState("");
  const [isTraining, setIsTraining] = useState(false);
  const [firstClass, setFirstClass] = useState(false);
  const [paymentValue, setPaymentValue] = useState("");
  const [openmodalpass, setOpenModalPass] = useState(false);
  const [globallanguages, setGlobalLanguages] = useState([]);
  const [alertdescription, setAlertDescription] = useState("");
  const [userEmails, setUserEmails] = useState([{ email: "", notify: true }]);
  const [userPhones, setUserPhones] = useState([{ phone: "", userPhoneTypeId: 1 }]);
  const [allOthersLanguages, setAllOthersLanguages] = useState([{ languageId: 0, isNative: false }]);
  const [allLanguage, setAllLanguage] = useState([
    {
      languageId: 0,
      isNative: true,
      levelExclusion: [
        { label: "A0", active: false },
        { label: "A1", active: false },
        { label: "A2", active: false },
        { label: "B1", active: false },
        { label: "B2", active: false },
        { label: "C1", active: false },
        { label: "C2", active: false },
        { label: "DM", active: false },
      ],
    },
  ]);

  const addTeacher = async (e) => {
    e.preventDefault();

    const newAllLanguages = allLanguage?.concat(allOthersLanguages);
    console.log(newAllLanguages);

    if (validateForm()) {
      let formData = {
        name: name.toString().trim(),
        email: email.toLowerCase().trim(),
        emails: userEmails,
        gender: gender,
        birthDate: birthDate,
        countryId: Number(countryId),
        timezone: timezone,
        address: address,
        userPhones: userPhones,
        firstClass: firstClass,
        demoClass: demoClass,
        isActive: isActive,
        isTraining: isTraining,
        payment: {
          paymentId: paymentID,
          paymentType: paymentType,
          paymentValue: paymentValue,
        },
        languages: newAllLanguages
          ?.filter((item) => item.languageId !== 0)
          ?.map((_, i) => {
            return {
              languageId: Number(newAllLanguages[i].languageId),
              isNative: newAllLanguages[i].isNative,
              levels: newAllLanguages[i]?.levelExclusion
                ?.filter((item) => item.active)
                ?.map((item) => {
                  switch (item.label) {
                    case "A0":
                      return 1;
                    case "A1":
                      return 2;
                    case "A2":
                      return 3;
                    case "B1":
                      return 4;
                    case "B2":
                      return 5;
                    case "C1":
                      return 6;
                    case "C2":
                      return 7;
                    case "DM":
                      return 8;
                  }
                }),
            };
          }),
      };

      await dispatch(postTeachers(formData))
        .then((res) => {
          if (res.success) {
            const newIdTeacher = res?.result?.items[0]?.teachers[0]?.id;
            const newTimeTable = {
              teacherAvailabilities: [
                { teacherId: newIdTeacher, weekDay: "0", startTime: "00:00:00", endTime: "00:00:00" },
                { teacherId: newIdTeacher, weekDay: "1", startTime: "00:00:00", endTime: "00:00:00" },
                { teacherId: newIdTeacher, weekDay: "2", startTime: "00:00:00", endTime: "00:00:00" },
                { teacherId: newIdTeacher, weekDay: "3", startTime: "00:00:00", endTime: "00:00:00" },
                { teacherId: newIdTeacher, weekDay: "4", startTime: "00:00:00", endTime: "00:00:00" },
                { teacherId: newIdTeacher, weekDay: "5", startTime: "00:00:00", endTime: "00:00:00" },
                { teacherId: newIdTeacher, weekDay: "6", startTime: "00:00:00", endTime: "00:00:00" },
              ],
            };

            dispatch(postTeacheravailabilities(newTimeTable))
              .then(() => {})
              .catch((err) => console.log(err));

            navigate("/teachers");
          }
        })
        .catch((error) => {
          setOpenAlert(true);
          setAlertTitle(t("ERROR"));
          setAlertDescription(error);
        });
    }
  };

  const updateTeacher = async (e) => {
    e.preventDefault();

    const newAllLanguages = allLanguage?.concat(allOthersLanguages);

    if (validateForm()) {
      let formData = {
        id: Number(id),
        gender: gender,
        role: "teacher",
        address: address,
        birthDate: birthDate,
        countryId: Number(countryId),
        name: name.toString().trim(),
        email: email.toLowerCase().trim(),
        timezone: timezone,
        userPhones: userPhones,
        userEmails: userEmails,
        firstClass: firstClass,
        demoClass: demoClass,
        isActive: isActive,
        isTraining: isTraining,
        payment: {
          paymentId: paymentID,
          paymentType: paymentType,
          paymentValue: paymentValue,
        },
        teacher: {
          id: Number(teacherId),
          languages: newAllLanguages
            ?.filter((item) => item.languageId !== 0)
            ?.map((_, i) => {
              return {
                languageId: Number(newAllLanguages[i].languageId),
                isNative: newAllLanguages[i].isNative,
                levels: newAllLanguages[i]?.levelExclusion
                  ?.filter((item) => item.active)
                  ?.map((item) => {
                    switch (item.label) {
                      case "A0":
                        return 1;
                      case "A1":
                        return 2;
                      case "A2":
                        return 3;
                      case "B1":
                        return 4;
                      case "B2":
                        return 5;
                      case "C1":
                        return 6;
                      case "C2":
                        return 7;
                      case "DM":
                        return 8;
                    }
                  }),
              };
            }),
        },
      };
      formData.userEmails?.map((email) => {
        delete email.id;
        delete email.userId;
        delete email.updatedAt;
        delete email.createdAt;
        delete email.deletedAt;
        delete email.userPhoneType;
      });

      formData.userPhones?.map((phone) => {
        delete phone.id;
        delete phone.userId;
        delete phone.updatedAt;
        delete phone.createdAt;
        delete phone.deletedAt;
        delete phone.userPhoneType;
      });

      await dispatch(putTeachers(formData))
        .then((res) => res.success && navigate("/teachers"))
        .catch((error) => {
          setOpenAlert(true);
          setAlertTitle(t("ERROR"));
          setAlertDescription(error);
        });
    }
  };

  const callApi = async () => {
    if (id) {
      await dispatch(getTeachersById(id))
        .then((res) => {
          const emailsForm = [];
          if (res?.email) {
            emailsForm.push({ email: decryptIfEncrypted(res?.email), notify: true });

            if (res?.userEmails.length > 0) {
              res?.userEmails.forEach(
                (item) =>
                  res?.email !== item.email &&
                  emailsForm.push({ email: decryptIfEncrypted(item.email), notify: item.notify }),
              );
            }
          }

          setIsActive(res.active);
          setPicture(res.picture);
          setTimezone(res.timezone);
          setCountryId(res.countryId);
          setUserEmails(emailsForm);
          setTeacherId(res.teachers[0]?.id);
          setName(decryptIfEncrypted(res.name));
          setEmail(decryptIfEncrypted(res.email));
          setDemoClass(res.teachers[0]?.demoClass);
          setGender(decryptIfEncrypted(res.gender));
          setFirstClass(res.teachers[0]?.firstClass);
          setAddress(decryptIfEncrypted(res.address));
          setPaymentValue(res.teachers[0]?.paymentValue);
          setBirthDate(decryptIfEncrypted(res.birthDate));
          setPaymentID(decryptIfEncrypted(res.teachers[0]?.paymentId));
          setPaymentType(decryptIfEncrypted(res.teachers[0]?.paymentType));
          setIsTraining(res?.teachers[0]?.isTraining === null ? false : res?.teachers[0]?.isTraining);
          setUserPhones(
            res.userPhones.map((item) => ({
              phone: decryptIfEncrypted(item.phone),
              userPhoneTypeId: item.userPhoneTypeId,
            })),
          );

          const newLevelExclusion = (item) => {
            const result = {};

            item.forEach((item) => {
              Object.entries(item).forEach(([idioma, valores]) => {
                if (!result[idioma]) result[idioma] = [];

                Object.entries(valores).forEach(([chave, valor]) => {
                  if (chave !== "undefined") {
                    result[idioma].push({ label: chave, active: valor });
                  }
                });
              });
            });
            return result;
          };

          setAllLanguage(
            res.teachers[0]?.teacherLanguages
              ?.filter((item) => item.isNative)
              ?.map((item) => ({
                isNative: item?.isNative,
                languageId: item?.languageId,
                levelExclusion: newLevelExclusion(res.languageLevelsHelper)[decryptIfEncrypted(item.language.name)],
              })),
          );

          setAllOthersLanguages(
            res.teachers[0]?.teacherLanguages
              ?.filter((item) => !item.isNative)
              ?.map((item) => ({ languageId: item?.languageId, isNative: item?.isNative })),
          );
        })
        .catch((err) => console.log("ERRO GET USERS ", err));
    }
  };

  const addEmail = (e) => {
    e.preventDefault();
    setUserEmails((state) => [...state, { email: "", notify: false }]);
  };

  const addPhone = (e) => {
    e.preventDefault();
    setUserPhones((state) => [...state, { phone: "", userPhoneTypeId: "" }]);
  };

  const removeEmail = (e, findIndex) => {
    e.preventDefault();
    setUserEmails((state) => state.filter((_, i) => i !== findIndex));
  };

  const addLanguage = (e) => {
    e.preventDefault();
    setAllLanguage((state) => [
      ...state,
      {
        languageId: 0,
        isNative: true,
        levelExclusion: [
          { label: "A0", active: false },
          { label: "A1", active: false },
          { label: "A2", active: false },
          { label: "B1", active: false },
          { label: "B2", active: false },
          { label: "C1", active: false },
          { label: "C2", active: false },
          { label: "DM", active: false },
        ],
      },
    ]);
  };
  const addOtherLanguages = (e) => {
    e.preventDefault();
    setAllOthersLanguages((state) => [...state, { languageId: 0, isNative: false }]);
  };

  const removeLanguage = (e, findIndex) => {
    e.preventDefault();
    setAllLanguage((state) => state.filter((_, i) => i !== findIndex));
  };

  const removeAllOtherLanguages = (e, findIndex) => {
    e.preventDefault();
    setAllOthersLanguages((state) => state.filter((_, i) => i !== findIndex));
  };

  const removePhone = (e, findIndex) => {
    e.preventDefault();
    setUserPhones((state) => state.filter((_, i) => i !== findIndex));
  };

  const handleChangeList = (e, index, secondIndex) => {
    e.preventDefault();
    const { name, value } = e.target;

    switch (name) {
      case "email":
        if (index === 0) setEmail(value);
        setUserEmails((state) => state.map((item, i) => (i === index ? { ...item, email: value } : item)));
        break;
      case "notify":
        setUserEmails((state) => state.map((item, i) => (i === index ? { ...item, notify: !item.notify } : item)));
        break;
      case "phone":
        setUserPhones((state) => state.map((item, i) => (i === index ? { ...item, phone: value } : item)));
        break;
      case "userPhoneTypeId":
        setUserPhones((state) => state.map((item, i) => (i === index ? { ...item, userPhoneTypeId: value } : item)));
        break;
      case "languageMain":
        setAllLanguage((state) =>
          state.map((item, i) => (i === index ? { ...item, languageId: Number(value) } : item)),
        );
        break;
      case "languageOther":
        setAllOthersLanguages((state) =>
          state.map((item, i) => (i === index ? { languageId: Number(value), isNative: false } : item)),
        );
        break;
      case "languageLevel":
        setAllLanguage((state) =>
          state.map((item, i) => {
            if (i === index) {
              const updatedLevelExclusion = item.levelExclusion.map((level, idx) =>
                secondIndex === idx ? { ...level, active: !level.active } : level,
              );
              return { ...item, levelExclusion: updatedLevelExclusion };
            }
            return item;
          }),
        );
        break;
    }
  };

  const validateForm = () => {
    if (name.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("NAME") }));

      return false;
    } else if (!/^\S+@\S+\.\S+$/.test(email) || email.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("EMAIL") }));

      return false;
    } else if (gender.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("GENDER") }));

      return false;
    } else if (!birthDate || moment(birthDate) >= moment().add(-1, "hours")) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("BIRTH_DATE") }));

      return false;
    } else if (allLanguage[0].languageId === 0) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("NATIVE_LANGUAGE") }));

      return false;
    } else if (countryId <= 0) {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("COUNTRY") }));

      return false;
    } else if (timezone.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("TIMEZONE") }));

      return false;
    } else if (address === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("ADDRESS") }));

      return false;
    } else if (userPhones.length === 0 || userPhones[0].phone.trim() === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("CELLPHONE") }));

      return false;
    } else if (userPhones.length === 0 || userPhones[0].userPhoneTypeId === "") {
      setOpenAlert(true);
      setAlertTitle(t("INVALID_FORM_TITLE"));
      setAlertDescription(t("FIELD_IS_REQUIRED", { fieldName: t("TYPE") }));

      return false;
    } else return true;
  };

  const openModalPassword = () => setOpenModalPass(true);
  const closeAlert = () => setOpenAlert(false);

  let dataNew = moment(new Date()).tz(timezone);
  moment.tz(timezone);

  let dataTimeZone = moment(dataNew).format("LT");

  useEffect(() => {
    callApi();
    dispatch(getCountries()).then((res) => setCountries(res));
    dispatch(getGlobalLanguages()).then((res) => setGlobalLanguages(res));
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <div className="box">
        {id && <PhotoAvatar userID={id} picture={picture} setPicture={setPicture} />}

        <form className="formulario">
          <div className="wrapperBlock">
            <h4 className="textBlock">{t("PERSONAL_DATA")}</h4>
          </div>

          <div>
            <label htmlFor="name">
              {t("NAME")}
              <span className="invalid">{t("REQUIRED_FIELD")}</span>
            </label>
          </div>
          <input
            required
            id="name"
            type="text"
            name="name"
            value={name}
            placeholder={t("NAME_PLACEHOLDER")}
            onChange={(e) => setName(e.target.value)}
          />

          {userEmails?.map((item, index) => (
            <div key={index}>
              <div>
                <label htmlFor={"email" + index}>
                  {index === 0 ? t("LOGIN_EMAIL") : t("EXTRA_EMAIL")}
                  {index === 0 && <span className="invalid">{t("REQUIRED_FIELD")}</span>}
                </label>
              </div>
              <div className="notification">
                <input
                  required
                  type="text"
                  name="email"
                  value={item.email}
                  className="newemail"
                  id={"email" + index}
                  placeholder={t("EXTRA_EMAIL_PLACEHOLDER")}
                  onChange={(e) => handleChangeList(e, index)}
                />
                <div className="switchBox">
                  <div className="switch__container">
                    <input
                      className="switch switch--shadow"
                      name="notify"
                      id={"notify" + index}
                      type="checkbox"
                      onChange={(e) => handleChangeList(e, index)}
                      checked={item.notify}
                    />
                    <label htmlFor={"notify" + index}>
                      <span>{t("NOTIFICATION")}</span>
                    </label>
                  </div>
                </div>
                {index === 0 ? (
                  <SCButtonAddInput name="addemail" onClick={(e) => addEmail(e)}>
                    {t("ADD_EMAIL")} +
                  </SCButtonAddInput>
                ) : (
                  <SCButtonAddInput id={index} name="remove" onClick={(e) => removeEmail(e, index)}>
                    {t("DELETE")} x
                  </SCButtonAddInput>
                )}
              </div>
            </div>
          ))}

          <div className="inputs">
            <div className="lineInputs">
              <div>
                <label htmlFor="gender">
                  {t("GENDER")}
                  <span className="invalid">{t("REQUIRED_FIELD")}</span>
                </label>
              </div>
              <select name="gender" value={gender} onChange={(e) => setGender(e.target.value)}>
                <option value="">{t("SELECT")}</option>
                <option value="notInformed">{t("NOT_INFORMED")}</option>
                <option value="male">{t("MALE")}</option>
                <option value="female">{t("FEMALE")}</option>
              </select>
            </div>

            <div className="lineInputs">
              <div>
                <label htmlFor="birthDate">
                  {t("BIRTH_DATE")}
                  <span className="invalid">{t("REQUIRED_FIELD")}</span>
                </label>
              </div>
              <input
                id="date"
                type="date"
                name="birthDate"
                value={birthDate}
                onChange={(e) => setBirthDate(e.target.value)}
              />
            </div>
          </div>

          <div className="wrapperBlock">
            <h4 className="textBlock">{t("COUNTRY")}</h4>
          </div>

          <div className="inputs">
            <div className="lineInputs">
              <div>
                <label htmlFor="countryId">
                  {t("COUNTRY")}
                  <span className="invalid">{t("REQUIRED_FIELD")}</span>
                </label>
              </div>
              <select name="countryId" value={countryId} onChange={(e) => setCountryId(e.target.value)}>
                <option value="">{t("SELECT")}</option>
                {countries?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="inputs">
            <div className="lineInputs timezoneCard">
              <div>
                <label htmlFor="timezone">
                  {t("TIMEZONE")}
                  <span className="invalid">{t("REQUIRED_FIELD")}</span>
                </label>
              </div>
              <TimezonePicker
                name="timezone"
                value={timezone}
                inputProps={{ placeholder: "Select Timezone..." }}
                onChange={(timezoneName) => setTimezone(timezoneName)}
              />
            </div>
            <div className="lineInputs">
              <p>
                {t("CURRENT_TIME")}
                <br /> {t("IN_THIS_TIMEZONE")}: {dataTimeZone}
              </p>
            </div>
          </div>

          <div>
            <label htmlFor="address">
              {t("ADDRESS")}
              <span className="invalid">{t("REQUIRED_FIELD")}</span>
            </label>
          </div>
          <input
            required
            name="address"
            value={address}
            placeholder={t("ADDRESS_PLACEHOLDER")}
            onChange={(e) => setAddress(e.target.value)}
          />

          {userPhones?.map((item, index) => (
            <div key={index} className="inputs">
              <div className="lineInputs">
                <div>
                  <label htmlFor={"phone" + index}>
                    {t("TELEPHONE")}
                    {index === 0 && <span className="invalid">{t("REQUIRED_FIELD")}</span>}
                  </label>
                </div>
                <input
                  name="phone"
                  value={item.phone}
                  id={"phone" + index}
                  required={index === 0}
                  placeholder={t("PHONE_PLACEHOLDER")}
                  onChange={(e) => handleChangeList(e, index)}
                />
              </div>
              <div className="lineInputs">
                <div>
                  <label htmlFor={"userPhoneTypeId" + index}>
                    {t("TYPE")}
                    <span className="invalid">{t("REQUIRED_FIELD")}</span>
                  </label>
                </div>
                <select
                  name="userPhoneTypeId"
                  id={"phoneType" + index}
                  value={item.userPhoneTypeId}
                  onChange={(e) => handleChangeList(e, index)}
                >
                  <option value="1">{t("COMMERCIAL")}</option>
                  <option value="2">{t("RESIDENCIAL")}</option>
                  <option value="3">{t("CELLPHONE")}</option>
                  <option value="4">{t("WHATSAPP")}</option>
                </select>
              </div>
              {index === 0 && (
                <div className="lineInputs">
                  <SCButtonAddInput name="addphone" onClick={(e) => addPhone(e)}>
                    {t("BTN_ADD_TEL")} +
                  </SCButtonAddInput>
                </div>
              )}
              {index > 0 && (
                <SCButtonAddInput id={index} name="remove" onClick={(e) => removePhone(e, index)}>
                  {t("BTN_DELETE")} X
                </SCButtonAddInput>
              )}
            </div>
          ))}

          {user?.role === "companyManager" && (
            <>
              <div className="wrapperBlock">
                <h4 className="textBlock">{t("PAYMENT")}</h4>
              </div>

              <div className="wrapperPayment">
                <div>
                  <label htmlFor="payment">
                    US $ / Class
                    <span className="invalid">{t("REQUIRED_FIELD")}</span>
                  </label>
                  <input
                    type="number"
                    name="paymentValue"
                    placeholder={"US"}
                    value={paymentValue}
                    onChange={(e) => setPaymentValue(e.target.value)}
                  />
                </div>

                <div className="lineInputs">
                  <div>
                    <label>
                      {t("PAYMENT")}
                      <span className="invalid">{t("REQUIRED_FIELD")}</span>
                    </label>
                  </div>
                  <select name="paymentType" value={paymentType} onChange={(e) => setPaymentType(e.target.value)}>
                    <option value="">{t("SELECT")}</option>
                    {optionsPayment?.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="lineInputs">
                  <label htmlFor="payment">
                    {t("PAYMENT_ID")}
                    <span className="invalid">{t("REQUIRED_FIELD")}</span>
                  </label>
                  <input
                    type="text"
                    name="paymentID"
                    value={paymentID}
                    placeholder={"ID"}
                    onChange={(e) => setPaymentID(e.target.value)}
                  />
                </div>
              </div>
            </>
          )}

          <div className="wrapperBlock">
            <h4 className="textBlock">{t("LANGUAGE")}</h4>

            <SCButtonAddInput name="addlanguage" onClick={(e) => addLanguage(e)}>
              {t("ADD_LANGUAGE")} +
            </SCButtonAddInput>
          </div>

          <div className="wrapperLanguage">
            {allLanguage?.map((language, index) => (
              <div key={index}>
                <div className="languageMain">
                  <select
                    name="languageMain"
                    className="language"
                    value={language.languageId}
                    onChange={(e) => handleChangeList(e, index)}
                  >
                    <option value="">{t("SELECT")}</option>
                    {globallanguages?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>

                  {index > 0 && (
                    <SCButtonAddInput name="remove" onClick={(e) => removeLanguage(e, index)}>
                      {t("DELETE")} x
                    </SCButtonAddInput>
                  )}
                </div>

                <div className="levelExclusion">
                  <label>{t("EXCLUSION_LEVELS")}</label>

                  <ul>
                    {language?.levelExclusion?.map((level, indexLevel) => (
                      <li key={indexLevel}>
                        <button
                          type="button"
                          name="languageLevel"
                          className={!level?.active ? "active" : ""}
                          onClick={(e) => handleChangeList(e, index, indexLevel)}
                        >
                          {level?.label}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="divSeparation" />
              </div>
            ))}

            <div className="otherLanguage">
              <div>
                <label>{t("OTHER_LANGUAGE")}</label>
                <SCButtonAddInput name="addOtherlanguage" onClick={(e) => addOtherLanguages(e)}>
                  {t("ADD_ANOTHER_LANGUAGE")} +
                </SCButtonAddInput>
              </div>

              <div className="wrapperOtherLanguage">
                {allOthersLanguages?.map((otherLanguage, indexOther) => (
                  <Fragment key={indexOther}>
                    <select
                      name="languageOther"
                      className="language"
                      value={otherLanguage.languageId}
                      onChange={(e) => handleChangeList(e, indexOther)}
                    >
                      <option value="">{t("SELECT")}</option>

                      {globallanguages?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>

                    <SCButtonAddInput name="remove" onClick={(e) => removeAllOtherLanguages(e, indexOther)}>
                      X
                    </SCButtonAddInput>
                  </Fragment>
                ))}
              </div>
            </div>
          </div>

          <div className="wrapperConfigButtons">
            <div className="lineInputs">
              <label htmlFor="isActive">{t("ISACTIVE")}</label>

              <div className="switch__container">
                <input
                  type="checkbox"
                  name="isActive"
                  checked={isActive}
                  id="switch-shadow3"
                  className="switch switch--shadow2"
                  onChange={() => setIsActive((state) => !state)}
                />
                <label htmlFor="switch-shadow3">{t("YES")}</label>
              </div>
            </div>

            <div className="lineInputs">
              <div>
                <label htmlFor="firstClass">{t("FIRST_CLASS")}</label>
                <div className="switch__container">
                  <input
                    type="checkbox"
                    name="firstClass"
                    id="switch-shadow1"
                    checked={firstClass}
                    className="switch switch--shadow2"
                    onChange={() => setFirstClass((state) => !state)}
                  />
                  <label htmlFor="switch-shadow1">{t("YES")}</label>
                </div>
              </div>
            </div>
            <div className="lineInputs">
              <div>
                <label htmlFor="demoClass">{t("DEMO_CLASS")}</label>
                <div className="switch__container">
                  <input
                    type="checkbox"
                    name="demoClass"
                    id="switch-shadow2"
                    checked={demoClass}
                    className="switch switch--shadow2"
                    onChange={() => setDemoClass((state) => !state)}
                  />
                  <label htmlFor="switch-shadow2">{t("YES")}</label>
                </div>
              </div>
            </div>

            <div className="lineInputs">
              <label htmlFor="isActive">{t("TRAINING")}</label>
              <div className="switch__container">
                <input
                  type="checkbox"
                  name="isActive"
                  id="switch-shadow4"
                  checked={isTraining}
                  className="switch switch--shadow2"
                  onChange={() => setIsTraining((state) => !state)}
                />
                <label htmlFor="switch-shadow4">{t("YES")}</label>
              </div>
            </div>

            <div>
              <div>
                <label htmlFor="password">{t("PASSWORD")}</label>
              </div>
              <button type="button" className="password" onClick={openModalPassword}>
                {t("CHANGE_PASSWORD")}
              </button>
            </div>
          </div>
        </form>
      </div>

      <div className="buttonSave">
        <button type="button" onClick={id ? updateTeacher : addTeacher}>
          {t("SAVE")}
        </button>
      </div>

      <Dialog
        open={openalert}
        onClose={closeAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="boxModal"
      >
        <DialogTitle id="alert-dialog-title">
          <span className="titleModal">{alerttitle}</span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="pass-dialog-description" className="boxModal">
            <span className="formulario">
              <span className="description">{alertdescription}</span>
            </span>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <div className="buttons">
            <button onClick={closeAlert} color="primary" autoFocus>
              {t("CLOSE")}
            </button>
          </div>
        </DialogActions>
      </Dialog>

      <ModalChangePassword id={id} showModal={openmodalpass} setShowModal={setOpenModalPass} />
    </div>
  );
}

export default ManageAccount;
